import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article21() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const go_to_next_page = (event, data) => {
    console.log(event.target);
    console.log(data);
    const fold_element = document.getElementsByClassName('fold');
    fold_element[0].classList.add("active");
  }

  const go_to_prev_page = (event, data) => {
    console.log(event.target);
    console.log(data);
    const fold_element = document.getElementsByClassName('fold');
    fold_element[0].classList.add("active");
  }

  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article22');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article20');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };
  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article21-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article21-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="mb-4 mb-sm-5" ref={firstContainer}>
              <h1 className="fs-xl f-lora mb-4 mb-sm-5"><span className="f-lora-i">The Art of</span> <br/>Self Catering</h1>
              <h3 className="mb-4 mb-sm-5 f-lora-i lh-base text-orange">Find a special place to coorie in <span className="ps-0 ps-md-4 d-block">while exploring Scotland’s best bits</span> </h3>
              
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <p className="">Hotels are great, but sometimes on holiday it’s important to have some extra space to spread out and properly relax. Self-catering accommodation is the perfect solution for stays when you want a bit more autonomy than a hotel typically offers, including the option of rustling up a hearty meal in the kitchen or breaking out a board game to play with friends in the lounge. </p>
                  <p className="">Scotland is blessed with a wide variety of selfcatering options, from remote off-grid cabins to luxurious inner-city apartments. The best of these provide a home away from home, with all of the amenities required to ensure a comfortable and convenient break. Whether you’re staying for a night or a fortnight, having a sofa to curl up on and a fridge full of food makes it feel as if you’re not merely passing through. </p>
                  <p className="mb-sm-0">Beautiful spaces go a long way to helping us relax and enjoy spending time somewhere new. The Scots word ‘coorie’ – meaning to cuddle up with a loved one – is commonly used to describe the sense of warmth and homeliness you can expect from the most stylish and considered holiday lets. It’s the intangible feeling you get when sharing a freshly prepared supper around a candlelit table, or savouring a glass of wine in front of a roaring fire. Somehow these experiences are amplified when staying in properties that encourage us to engage in a slower pace of life. </p>
                </div>
                <div className="col-sm-6">
                  <p className="">Self-catering holidays give you a chance to explore the local area from your temporary home. You can head out for walks or day trips carrying only the essentials and when you return there will be somewhere to hang up raincoats and store muddy boots (this is Scotland after all!). Hosts will often provide a guide to the local area, including activities and details of places where you can pick up tasty regional produce to cook with. This engagement with the countryside and the community can help forge a bond with a place that will make you more likely to return time after time. </p>
                  <p className="mb-0">When choosing your accommodation, be sure to read reviews and look at photos to determine how well suited a property is to your unique requirements. Does it allow pets or children? How accessible is it? Does it come with mod cons and gadgets or is it somewhere without WiFi where you can switch off completely and recharge? Online resources, apps and booking services such as AirBnB and Vrbo make it easier than ever before to find appropriate accommodation in your ideal location. You can also discover details of some of our favourite places to stay on the Hidden Scotland website (hiddenscotland.co), including the examples shared over the following pages. These properties make us feel comfortable the moment we step through the door and sad to leave when the time comes to check out. We hope you’ll feel the same way. </p>
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6 mb-4 mb-sm-0">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img1.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">Queens Hut </h4>
                  <h5 className="mb-4 f-lora-i">Aboyne, Aberdeenshire</h5>
                  <p className="mb-0">This picture-perfect log cabin on the shores of a tranquil loch in Aberdeenshire provides an ideal escape for up to four people. Originally built for Queen Mary, the wife of King George V, the rustic residence has been renovated to a high standard but still retains many of its original features. A modern, country style kitchen contains everything required for rustling up a hearty meal or a picnic to enjoy whilst exploring Royal Deeside. A large window seat provides an ideal spot for reading or wildlife watching, and you can also soak in the view over the loch from a freestanding copper bathtub in the main bedroom. </p>
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img2.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">Eastside Cottages </h4>
                  <h5 className="mb-4 f-lora-i">Pentland Hills, Lothian</h5>
                  <p className="mb-0">Architecture meets Agritourism’ is the tagline for this stylish accommodation located on a working farm in the Pentland Hills Regional Park near Edinburgh. The Cartshed and Wash House are the latest parts of the 18thcentury farmstead to be converted into self-catering units for short-term holiday lets. The clean-lined, contemporary interiors feature open-plan living spaces that are slotted into the existing buildings and divided using level changes, handcrafted ash screens and bespoke cabinetry. Guests can relax in front of a log-burning stove or spend an evening unwinding in the farm spa’s enchanting woodland yurt sauna. </p>
                </div>
              </div>
              
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6 mb-4 mb-sm-5">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img3.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">The Treehouses at Lanrick </h4>
                  <h5 className="mb-4 f-lora-i">Near Doune, Perthshire</h5>
                  <p className="mb-0">Live out a childhood fantasy by spending a few nights in a luxuriously appointed treehouse at this estate in the heart of picturesque Perthshire. Youngsters and the young at heart will love looking out onto the forest canopy from the cosy lounge areas or large elevated decks. Two of the treehouses are connected by a rope bridge, providing a great option for families and groups travelling together. Owners Simon and Louisa Dickson have given each custom-built treehouse a distinct personality, with handcrafted tables, upcycled furniture, outdoor bathtubs and wood-burning stoves contributing to the coorie vibe. </p>
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img4.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">Ainster House </h4>
                  <h5 className="mb-4 f-lora-i">Anstruther, Fife</h5>
                  <p className="mb-0">Spread across two floors of a former 18th-century coachhouse overlooking the Dreel River, this large selfcatering property offers all the home comforts you could wish for. Ainster House has four bedrooms, a spacious living area and two outdoor terraces with views of the nearby harbour, as well as a fully fitted kitchen and plenty of mod cons. The decor is cool and considered, creating a tranquil and comfortable space for relaxing or entertaining. The beautiful Fife Coastal Trail is on the doorstep and Ainster House is located within close range of many world-class golf courses, including the famous Old Course at St Andrews. </p>
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6 mb-4 mb-sm-5">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img5.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">Creag na h-Iolaire </h4>
                  <h5 className="mb-4 f-lora-i">Shieldaig, Torridon</h5>
                  <p className="mb-0">A stunning panorama taking in Loch Torridon and the Torridon mountains is the main attraction at this luxurious self-catering lodge near Shieldaig on Scotland’s wild west coast. Creag na h-Iolaire was designed by award-winning architects Dualchas from Skye, who created an openplan living area lined with floor-to-ceiling windows that help to immerse guests in the cinematic surroundings. The modern kitchen is a great space for socialising and preparing meals from local produce, which you can source using the extensive guide to the area provided by the hosts. </p>
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img6.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">Kabn Company </h4>
                  <h5 className="mb-4 f-lora-i">Loch Fyne, Argyll</h5>
                  <p className="mb-0">Kabn Company’s minimalist off-grid cabins are tucked away in a secret location on the shores of Loch Fyne and provide an ideal escape from the stresses of everyday life. The two architect-designed eco cabins make the most of their compact dimensions, with an en-suite bedroom at one end separated from the living area by a central partition. The simple kitchen includes a larder of herbs, spices and oils to make eating in easy. You can cook on the gas hob or use a small oven insert above the woodburning stove. Alternatively, head outdoors to make use of the barbecue or toast marshmallows over the fire pit. </p>
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6 mb-4 mb-sm-5">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img7.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">Observatory House </h4>
                  <h5 className="mb-4 f-lora-i">Edinburgh</h5>
                  <p className="mb-0">Occupying one of the most iconic locations in Edinburgh, Observatory House looks out over the capital from high up on Calton Hill. The house built in the 18th century to accommodate leading astronomers had stood empty for years until it was revived by the Collective centre for contemporary art as a unique holiday destination. Both the main house and a smaller basement apartment have been decorated in a modern style and feature commissioned works by Scotland-based artists. Cooking in the bespoke kitchen created by artist Thomas Aitchison is a special experience, but if you prefer to eat out then The Lookout restaurant run by Collective’s partners at The Gardener’s Cottage is just a few metres away. </p>
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid mb-4"
                    src={require("../../Images/article21-right-img8.jpg")}
                  />
                  <h4 className="fs-md mb-1 f-lora">Loch Venachar Lodges </h4>
                  <h5 className="mb-4 f-lora-i">Loch Venachar</h5>
                  <p className="mb-0">These stylish lodges provide the perfect base for exploring the ever-popular Loch Lomond & The Trossachs National Park. Looking out over Loch Venachar towards Ben Venue, the Coorie and Carsaig lodges both offer direct access to the water for activities such as paddleboarding or windsurfing. After a busy day on the loch or exploring the surrounding countryside, you can retreat to a cosy lounge with a wood-burning stove or get cooking in the well-equipped kitchen. Anyone keen on unique, visually striking accommodation should book the Coorie lodge, which is a modern black box with living areas oriented to make the most of the spectacular views. </p>
                </div>
              </div>
            </div>

          </div>



        </div>
      </motion.div>

      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article21;
